


<div #finish>
  <div class="container-bienvenida" #containerBienvenida>
    <div class="container-izq" *ngIf="isDesktop && video" #containerIzq>

      <div class="video-wrapper ">
        <iframe width="100%" height="100%" [src]="safeVideoUrl" frameborder="0" allowfullscreen>
        </iframe>
      </div>
    </div>

    <div class="container-izq" *ngIf="!isDesktop && video" #containerIzq>
      <div class="video-wrapper ">
        <iframe width="100%" height="100%" [src]="safeVideoUrl" frameborder="0" allowfullscreen>
        </iframe>
      </div>

    </div>
    <div class="img-container" #imgContainer>
      <div class="content-wrapper" [class.expanded]="expanded" #contentWrapper>
        <div >
          <h2 class="quicksand-regular text-center">{{ title }}</h2>
        </div>

        <div [innerHTML]="htmlEstudiar" class="lista-container nunito-medium"></div>
      </div>


      <div class="extra" #extra>
        <div class="expand-container" *ngIf="showExpandButton">
          <a (click)="toggleExpand()" class="expand-button">
            {{ expanded ? 'ver -' : 'ver +' }}
          </a>
        </div>

       
      </div>

    </div>
  </div>
</div>